import axios from 'axios';
import {
  requestSuccessFn,
  requestFailFn,
  responseSuccessFn,
  responseFailFn,
  requestSuccessForPrefix,
  requestSuccessForPost,
  requestFailForPrefix,
  requestFailForPost,
  responseSuccessForPrefix,
  responseSuccessForPost,
  responseFailForPrefix,
  responseFailForPost,
} from './interceptors';

// 使用配置中心提供的默认配置创建 axios 实例
const axiosInstance = axios.create({
  timeout: 30000,
  // maxContentLength: 2000,
  withCredentials: true,
});

// 注入请求拦截器-成功
// 栈：先进后出
axiosInstance.interceptors.request.use(requestSuccessForPost);
axiosInstance.interceptors.request.use(requestSuccessFn);
axiosInstance.interceptors.request.use(requestSuccessForPrefix);

// 注入请求拦截器-失败
axiosInstance.interceptors.request.use(undefined, requestFailForPrefix);
axiosInstance.interceptors.request.use(undefined, requestFailFn);
axiosInstance.interceptors.request.use(undefined, requestFailForPost);

// 注入响应拦截器-成功
// 队列：先进先出
axiosInstance.interceptors.response.use(responseSuccessForPrefix);
axiosInstance.interceptors.response.use(responseSuccessFn);
axiosInstance.interceptors.response.use(responseSuccessForPost);

// 注入响应拦截器-失败
// 队列：先进先出
axiosInstance.interceptors.response.use(undefined, responseFailForPrefix);
axiosInstance.interceptors.response.use(undefined, responseFailFn);
axiosInstance.interceptors.response.use(undefined, responseFailForPost);

export default axiosInstance;
